import { Carousel } from 'antd';
import React from 'react';
import styles from './index.less'
import Header from "components/Header"
import classNames from 'classnames';
import Page1 from './components/page1'
import Page2 from './components/page2'
import Page3 from './components/page3'
import Page4 from './components/page4'
import Page5 from './components/page5'
import Page6 from './components/page6'
import { connect } from 'react-redux'


class Home extends React.Component {
  state = {
    currentCarousel: 0
  }
  containerRef = React.createRef()
  carouselRef = React.createRef()
  goto = (slideNumber) => {
    this.carouselRef.current.goTo(slideNumber, false)
  }
  onChange = (from, to) => {
    this.setState({
      currentCarousel: to
    })
    if (to == 0) {
      document.querySelector('html').style.backgroundColor = '#dde2ed'
    } else if (to == 5) {
      document.querySelector('html').style.backgroundColor = '#f6f6f9'
    } else {
      document.querySelector('html').style.backgroundColor = 'white'
    }
  };
  componentDidMount() {
    this.goto(0)
    this.containerRef.current.onmousewheel = e => {
      console.log(this.state.currentCarousel);
      if (e.wheelDelta > 0) {
        //向上滚动
        if (this.state.currentCarousel > 0) {
          this.carouselRef.current.prev()
        }
      } else {
        //向下滚动
        if (this.state.currentCarousel < 5) {
          this.carouselRef.current.next()
        }
      }
    }
    const handleDOMMouseScroll = e => {
      console.log(this.state.currentCarousel);
      if (e.detail < 0) {
        //向上滚动
        if (this.state.currentCarousel > 0) {
          this.carouselRef.current.prev()
        }
      } else {
        //向下滚动
        if (this.state.currentCarousel < 5) {
          this.carouselRef.current.next()
        }
      }
    }
    this.containerRef.current.addEventListener('DOMMouseScroll', handleDOMMouseScroll)
  }
  render() {
    return (
      <div ref={this.containerRef} className={styles.container} id='home_container'>
        <header className={styles.header}>
          <Header />
        </header>
        <Carousel dotPosition='right' ref={this.carouselRef} beforeChange={this.onChange} speed={1000}>
          <div>
            <div className={classNames(styles['carousel-item'])}>
              <Page1 />
            </div>
          </div>
          <div>
            <div className={classNames(styles['carousel-item'])}>
              <Page2 />
            </div>
          </div>
          <div>
            <div className={classNames(styles['carousel-item'])}>
              <Page3 />
            </div>
          </div>
          <div>
            <div className={classNames(styles['carousel-item'])}>
              <Page4 />
            </div>
          </div>
          <div>
            <div className={classNames(styles['carousel-item'])}>
              <Page5 />
            </div>
          </div>
          <div>
            <div className={classNames(styles['carousel-item'])} style={{pointerEvents:'none'}}>
              <Page6 />
            </div>
          </div>
        </Carousel>
      </div>
    )
  }
}

export default connect(
  state => {
    return {
      state
    }
  }
)(Home)